export enum PaymentType {
  INTERBANK,
  PAYPAL,
  STRIPE,
  FREE,
  STRIPE_ONCE
}
